// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { apiProxy, apiUrl } from './index';
import { IPageParams, IPageResult, adaptPageParams, adaptPageResult } from './utils';

export async function logout(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.logout}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>(`${apiProxy}${apiUrl.login}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function loginBroadview(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<{ data: { code: number; msg: string; token: string } }>('/broadview/directLogin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function sendSMS(body: API.VerifyParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>(`${apiProxy}${apiUrl.sendSMS}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function verifySMS(body: API.VerifyParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>(`${apiProxy}${apiUrl.verifySMS}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function fetchUser(options?: { [key: string]: any }) {
  return request<API.UserResult>(`${apiProxy}${apiUrl.userinfo}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateUser(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userinfoName}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function updatePwd(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userinfoPwd}`, {
    method: 'PUT',
    ...(options || {}),
  });
}

export async function fetchAccounts(params: IPageParams): Promise<API.ListResult> {
  const res = await request<IPageResult>(`${apiProxy}${apiUrl.users}`, {
    method: 'GET',
    params: adaptPageParams(params),
  });
  return adaptPageResult(res);
}

export async function addAccount(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userUpdate()}`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function deleteAccount(id: string | number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userUpdate(id)}`, {
    method: 'DELETE',
  });
}

export async function updateAccount({ id, ...data }: { id: string | number; [key: string]: any }) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userUpdate(id)}`, {
    method: 'PUT',
    data,
  });
}

export async function resetAccount(id: string | number, type: number) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userReset(id, type)}`, {
    method: 'PUT',
  });
}

export async function fetchAllPermissions() {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userPermissionsAll}`, {
    method: 'GET',
  });
}

export async function fetchUserPermissions(id: string | number = '', params: IPageParams = {}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userPermissionsQuery(id)}`, {
    method: 'GET',
    params,
  });
}

export async function updateUserPermissions({
  id,
  ...data
}: {
  id: string | number;
  [key: string]: any;
}) {
  return request<Record<string, any>>(`${apiProxy}${apiUrl.userPermissions(id)}`, {
    method: 'PUT',
    data,
  });
}
